<style>
</style>

<template>
  <v-menu
    v-model="show"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list>
      <v-list-tile
        @click="exportData('csv')"
        key="csv"
      >
        <v-list-tile-title>Pobierz CSV</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        @click="exportData('xlsx')"
        key="xlsx"
      >
        <v-list-tile-title>Pobierz XLSX</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="typeSource == 'attr-table'"
        @click="exportData('shp')"
        key="shp"
      >
        <v-list-tile-title>Pobierz SHP</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="typeSource == 'attr-table'"
        @click="exportData('geojson')"
        key="geojson"
      >
        <v-list-tile-title>Pobierz GEOJSON</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import exportTableData from "../../utils/exportTableData.js";

export default {
  props: {
    typeSource: {
      type: String,
      required: false,
      default: 'ag-grid'
    },
    columnDefs: {
      type: Array,
      required: false
    },
    gridOptions: {
      type: Object,
      required: false
    },
    filtredItems: {
      type: Array,
      required: false
    },
    srid: {
      type: String,
      required: false
    },
    projection: {
      type: String,
      required: false
    },
    fields: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    show: false,
    x: 0,
    y: 0
  }),
  methods: {
    exportData(type = 'csv') {
      if(this.typeSource === 'ag-grid') {
        exportTableData.agGrid(this.columnDefs, this.gridOptions, type);
      } else if(this.typeSource === 'attr-table') {
        exportTableData.attrTable(this.filtredItems, {
          srid: this.srid,
          projection: this.projection,
          fields: this.fields
        }, type);
      }
    },
    showExportMenu(e) {
      e.preventDefault();
      this.show = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/ExportTableData.vue